export default {
    interestsList(state) {
        return state.interestsList;
    },

    alertStatus(state) {
        return state.alertStatus;
    }

}


// WEBPACK FOOTER //
// ./src/store/getters.js